export const UPLOAD_REDUCER_STATE_ID = 'upload';
export const ROUTE_UPLOAD = '/upload';
